export default __webpack_public_path__ + "static/media/מועמדים-פוטושופ---סופי_0022s_0000_Black-&-White-36.218412d0.png";